import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HomeBannerComponent } from './home-banner.component';
import { AppAnalyticsModule } from '../../../directives/app-analytics.module';

@NgModule({
    declarations: [HomeBannerComponent],
    imports: [CommonModule, AppAnalyticsModule],
    exports: [HomeBannerComponent],
})
export class HomeBannerModule {}
